import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Componente che reindirizza automaticamente alla pagina personalizzata delle leghe
export const LegaRedirect = () => {
    const navigate = useNavigate();
    
    useEffect(() => {
        // Reindirizza immediatamente alla pagina personalizzata
        navigate('/leghe', { replace: true });
    }, [navigate]);
    
    // Mostra un messaggio di caricamento mentre reindirizza
    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '200px',
            fontSize: '16px',
            color: '#666'
        }}>
            Reindirizzamento alla gestione leghe...
        </div>
    );
};
